import StateComponent from '../../../../../../js/StateComponent'
import LightBox from '../../../../../../js/components/LightBox'
import ExportICalLightBoxHeader from './ExportICalLightBoxHeader'
import ExportICalLightBoxFooter from './ExportICalLightBoxFooter'
import ExportICalLightBoxContent from './ExportICalLightBoxContent'
import {bindActionCreators} from 'redux'
import {connect} from '../../../../../../js/redux/utils'
import {isDateRangeSelectionValid, isExportLightBoxDataChanged, isExportLightBoxShown} from '../selectors'
import {closeICalLightBox, exportICal} from '../actions'
import $ from '../../../../../../js/alias/jquery'
import {isUserActionLoading} from '../../../selectors'

class ExportICalLightBox extends StateComponent {
    constructor({
        exportICal,
        closeICalLightBox,
    }) {
        super()

        this.actions = {
            exportICal,
            closeICalLightBox,
        }

        this.state = {
            shown: false,
            dateRangeSelectionValid: false,
            dataChanged: false,
            loading: false,
        }

        this.onStatePropertyChanged('shown', shown => this.lightBox.toggle(shown))
        this.onStatePropertyChanged('dateRangeSelectionValid', dateRangeSelectionValid =>
            this.footer.setState({getFileButtonEnabled: dateRangeSelectionValid}))
        this.onStatePropertyChanged('dataChanged', dataChanged => this.lightBox.dataChanged = dataChanged)
        this.onStatePropertyChanged('loading', loading => this.footer.setState({loading}))

    }

    init() {
        this.header = new ExportICalLightBoxHeader()
        this.footer = new ExportICalLightBoxFooter({
            onCancelButtonClick: this.actions.closeICalLightBox,
            onGetFileButtonClick: this.actions.exportICal,
        })
        this.content = new ExportICalLightBoxContent()

        this.lightBox = new LightBox(
            $('body'),
            {
                cancel_confirmation_message_key: 'lightbox.cancel_changes',
            }).init({
            id: 'exportICalLightBox',
            header: this.header,
            content: this.content,
            footer: this.footer,
            classNames: 'exportFeedLightBox iCalLightBox',
            cancelCallback: this.actions.closeICalLightBox,
        })

        return this
    }
}

export default connect(
    state => ({
        shown: isExportLightBoxShown(state),
        dateRangeSelectionValid: isDateRangeSelectionValid(state),
        dataChanged: isExportLightBoxDataChanged(state),
        loading: isUserActionLoading(state),
    }),
    dispatch => bindActionCreators({
        exportICal,
        closeICalLightBox,
    }, dispatch)
)(ExportICalLightBox)



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/lightbox/export/ExportICalLightBox.js